// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"b5993a71","415":"b84519b9","499":"8e84f704"}[chunkId] + ".chunk.js";
};